import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ActivityIndicator = () => {

  return (
    <div>
      <div colSpan='11' style={{ textAlign: 'center', marginTop: '15px' }}>
        <FontAwesomeIcon icon='circle-notch' size='3x' style={{ color: '#07003C' }} spin />
      </div>
    </div>
  )

};


export default ActivityIndicator;



// WEBPACK FOOTER //
// ./src/components/App/ActivityIndicator/ActivityIndicator.js